import { ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';
import cx from 'classnames';
import React, { FC } from 'react';
import { CanvasInfo } from '../../../model/BadgeModel';
import { AddText, ExtendZoom, Move, RedlineCircle, RedlineFilledRectangle, RedlineFreeHand, Select } from '../MenuBar/Icons';
import { MenuItems, withMenuActions } from '../WithMenuActions/WithMenuActions';
import styles from './floatingItems.module.scss';

const ZoomMenuBar: FC<CanvasInfo> = withMenuActions(({ disabled, handleMenuActions }) => {
	return (
		<div className={styles.zoomMenuBar}>
			<ul>
				<li className={cx({ [styles.disabled]: disabled })} key={MenuItems.Selection} onClick={() => handleMenuActions(MenuItems.Select)}>
					<span title={_('Selection')}>
						<Select elementStyle={{ height: 17, width: 21 }} />
					</span>
				</li>
				<li className={cx({ [styles.disabled]: disabled })} key={MenuItems.Move} onClick={() => handleMenuActions(MenuItems.Move)}>
					<span title={_('Move')}>
						<Move />
					</span>
				</li>
				<li className={cx({ [styles.disabled]: disabled })} key={MenuItems.ZoomOut} onClick={() => handleMenuActions(MenuItems.ZoomOut)}>
					<span title={_('ZoomOut')}>
						<ZoomOutOutlined style={{ fontSize: '1.33em' }} />
					</span>
				</li>
				<li className={cx({ [styles.disabled]: disabled })} key={MenuItems.ZoomIn} onClick={() => handleMenuActions(MenuItems.ZoomIn)}>
					<span title={_('ZoomIn')}>
						<ZoomInOutlined style={{ fontSize: '1.33em' }} />
					</span>
				</li>
				<li className={cx({ [styles.disabled]: disabled })} key={MenuItems.ExtendZoom} onClick={() => handleMenuActions(MenuItems.ExtendZoom)}>
					<span title={_('ExtendZoom')}>
						<ExtendZoom />
					</span>
				</li>
				<li
					className={cx({ [styles.disabled]: disabled })}
					key={MenuItems.RedlineFreeHand}
					onClick={() => handleMenuActions(MenuItems.RedlineFreeHand)}>
					<span title={_('Line')}>
						<RedlineFreeHand />
					</span>
				</li>
				<li
					className={cx({ [styles.disabled]: disabled })}
					key={MenuItems.RedlineFilledRectangle}
					onClick={() => handleMenuActions(MenuItems.RedlineFilledRectangle)}>
					<span title={_('RectangleFill')}>
						<RedlineFilledRectangle />
					</span>
				</li>
				<li className={cx({ [styles.disabled]: disabled })} key={MenuItems.RedlineCircle} onClick={() => handleMenuActions(MenuItems.RedlineCircle)}>
					<span title={_('Circle')}>
						<RedlineCircle />
					</span>
				</li>
				{/* <li className={cx({ [styles.disabled]: disabled })} key={MenuItems.MonitorZone}>
					<span title={_('MonitorZone')}>
						<MonitorZone />
					</span>
				</li> */}
				<li className={cx({ [styles.disabled]: disabled })} key={MenuItems.AddText} onClick={() => handleMenuActions(MenuItems.AddText)}>
					<span title={_('AddText')}>
						<AddText />
					</span>
				</li>
			</ul>
		</div>
	);
});

export { ZoomMenuBar };
